import { defineStore } from 'pinia';
import { ref } from 'vue';

import { CarTripModalType } from '../models';

export const useCarTripModalsStore = defineStore('carTripModalsStore', () => {
  // State
  const carTripModalType = ref<CarTripModalType>(CarTripModalType.None);
  // Actions
  function openMissedChangePaxesModal(): void {
    carTripModalType.value = CarTripModalType.MissedChangePaxes;
  }

  function closeMissedChangePaxesModal(): void {
    carTripModalType.value = CarTripModalType.None;
  }

  return {
    // State
    carTripModalType,

    // Actions
    openMissedChangePaxesModal,
    closeMissedChangePaxesModal,
  };
});
